import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class RouteUrl {
  readonly agentResult: string = "results";
  readonly agentProfile: string = "profile";
  readonly agentProfileWithId: string = "profile/:id";
  readonly sendReferral: string = "sendreferral/:receiverID";
  readonly referralListing: string = "referrallisting";

  readonly referralDetails: string = "referraldetails/:id";
  readonly propertyInfo: string = "property-info/:id";
  readonly manageListings: string = "managelistings";
  readonly contactMe: string = "contactme";
  readonly contactMeWithId: string = "contactme/:agentId";
  readonly updateActivity: string = "updateactivity";
  readonly updateActivityWithId: string = "updateactivity/:id";

  readonly logActivityProfileVisits: string = "activitylogs/profilevisits";
  readonly logActivityContactMe: string = "activitylogs/contactme";
  readonly uploadVideo: string = "uploadvideo";
  readonly uploadCoverPhoto: string = "uploadcoverphoto";
  readonly addUpdateMLSnumber: string = "addUpdateMLSnumber";
  readonly adminReports: string = "reports";

}
